import { Box } from 'reflexbox';
import styled from 'styled-components';

const Pill = styled(Box)<{ small?: boolean; lightBlue?: boolean }>`
	color: ${(props) => props.theme.colors.slateBlue};
	background-color: ${(props) => props.theme.colors.whiteBlue};
	display: inline-block;
	font-weight: 400;

	${(props) =>
		props.lightBlue &&
		`
		color: ${props.theme.colors.slateBlue};
		background-color: ${props.theme.colors.lightBlue};
	`}

	${(props) =>
		props.small
			? `
			padding: 3px 12px;
		 	font-size: 12px;`
			: `
			padding: 5px 18px;
			font-size: 15px;
		`};
	border-radius: 15px;
	font-size: 15px;
`;

export { Pill };
